export default "__VITE_ASSET__BeG4g43s__"